<template>
  <v-container class="pt-0">
    <v-row justify="center">
      <v-dialog
        v-model="open"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Datos del Docente</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text v-bind="attrs" v-on="on">
                    <v-btn disabled dark text color="warning">
                      <v-icon class="mr-2">mdi-delete-forever</v-icon> Eliminar
                    </v-btn>
                  </v-btn>
                </template>
                <span>No se permite eliminar docentes</span>
              </v-tooltip>

              <v-btn dark text @click="saveDialog">
                <v-icon class="mr-2">mdi-content-save-edit</v-icon> Guardar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Nombre"
                    required
                    v-model="docente.nombre"
                    class="my-input"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field
                    label="Apellidos"
                    required
                    v-model="docente.apellidos"
                    class="my-input"
                  />
                </v-col>
                <v-col cols="8" sm="4" md="3">
                  <v-text-field
                    label="R.F.C."
                    v-model="docente.rfc"
                    class="my-input"
                  />
                </v-col>
                <v-col cols="4" sm="2" md="2">
                  <v-select
                    v-model="docente.activo"
                    :items="[
                      { text: 'SI', value: '1' },
                      { text: 'NO', value: '0' },
                    ]"
                    label="Activo"
                    required
                  />
                </v-col>
                <v-col cols="6" sm="3" md="3">
                  <v-select
                    v-model="docente.sexo"
                    :items="[
                      { text: 'HOMBRE', value: 'H' },
                      { text: 'MUJER', value: 'M' },
                    ]"
                    label="Sexo"
                    required
                  />
                </v-col>
                <v-col cols="6" sm="3" md="3">
                  <v-select
                    v-model="docente.turno"
                    :items="[
                      { text: 'VESPERTINO', value: 'TV' },
                      { text: 'MATUTINO', value: 'TM' },
                      { text: 'MIXTO', value: 'MX' },
                    ]"
                    label="Turno"
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Grado máximo de estudios"
                    v-model="docente.grado_maximo_estudios"
                    class="my-input"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-text-field
                    label="Estudió"
                    v-model="docente.estudio"
                    class="my-input"
                  />
                </v-col>
                <v-col cols="12" sm="8" md="5">
                  <v-text-field
                    label="Egresó de"
                    v-model="docente.egreso_de"
                    class="my-input"
                  />
                </v-col>
                <v-col cols="6" sm="4" md="2">
                  <v-text-field
                    label="Ingreso a SEP"
                    v-model="docente.ingreso_sep"
                  />
                </v-col>
                <v-col cols="6" sm="4" md="3">
                  <v-text-field
                    label="Ingreso a DGETI"
                    v-model="docente.ingreso_subsistema"
                  />
                </v-col>
                <v-col cols="6" sm="4" md="3">
                  <v-text-field
                    label="Horas totales en su(s) plaza(s)"
                    v-model="docente.plaza_horas"
                  />
                </v-col>
                <v-col cols="6" sm="4" md="3">
                  <v-text-field
                    label="Horas frente a grupo"
                    v-model="docente.maximo_horas_frente_a_grupo"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-text-field label="Celular" v-model="docente.celular" />
                </v-col>
                <v-col cols="12" sm="8" md="12">
                  <v-text-field
                    label="Correo electrónico"
                    v-model="docente.email"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="deleteDlg" persistent max-width="500">
        <v-card>
          <v-card-title class="headline"> Confirma Eliminación </v-card-title>
          <v-card-text
            >Por favor confirma que deseas eliminar el registro de este
            docente.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteDlg = false"> Cancelar </v-btn>
            <v-btn color="red darken-1" text @click="deleteDialog">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Docente",

  props: {
    open: Boolean,
    docente: Object,
  },

  data: () => ({
    dialog: false,
    deleteDlg: false,
  }),

  methods: {
    closeDialog() {
      this.$emit("exit");
    },

    deleteDialog() {
      this.deleteDlg = false;
      this.$emit("delete");
    },

    saveDialog() {
      let items = this.docente;
      for (let key in items) {
        if (key != "email" && key != "created_at" && key != "updated_at")
          items[key] = items[key].toUpperCase();
      }
      this.$emit("save");
    },
  },

  mounted() {},
};
</script>

<style>
.my-input input {
  text-transform: uppercase;
}
</style>